/* eslint-disable */
// /src/pages/StoreCartCheckoutPage.jsx

import React, { useEffect, useMemo, useState, useRef } from "react";
import styled from "styled-components";
import { useLocation, useNavigate } from "react-router-dom";
import BrandHeader from "../components/BrandHeader";
import PageTopBar from "../components/PageTopBar";
import { useDriverStatusContext } from "../context/DriverStatusContext";
import { createStoreOrder, updateStoreOrder } from "../services/storeOrderService";
import { deleteStoreCartItem } from "../services/storeCartService";
import {
    getDefaultOrderProfile,
    saveDefaultOrderProfile,
    clearDefaultOrderProfile,
} from "../services/storeProfileService";
import { fetchStoreSettings, fetchProductById } from "../services/storePublicService";

import { fetchMemberPointsBalance, applyPointsChange } from "../services/pointsService";

const Wrap = styled.div`
  min-height: 100vh;
  background: linear-gradient(180deg, #d7e8ff 0%, #eaf3ff 100%);
  display: flex;
  flex-direction: column;
`;

const Sheet = styled.div`
  background: #f7faff;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.05);
`;

const Body = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 18px 16px 20px;
  max-width: 760px;
  width: 100%;
  margin: 0 auto;
`;

const InfoText = styled.div`
  font-size: 13px;
  color: #64748b;
  line-height: 1.6;
`;

/* 상품 리스트 카드 */
const ItemsBox = styled.div`
  border-radius: 16px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  padding: 12px 14px;
  box-shadow: 0 3px 14px rgba(15, 23, 42, 0.05);
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const ItemRow = styled.div`
  display: flex;
  gap: 10px;
  align-items: flex-start;
  padding-bottom: 8px;
  border-bottom: 1px dashed #e5e7eb;

  &:last-child {
    border-bottom: 0;
    padding-bottom: 0;
  }
`;

const Thumb = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }
  span {
    font-size: 11px;
    color: #9ca3af;
  }
`;

const ItemContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

const ItemTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
`;

const ItemOption = styled.div`
  font-size: 12px;
  color: #6b7280;
`;

const ItemMetaRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 2px;
`;

const ItemQty = styled.div`
  font-size: 12px;
  color: #6b7280;
`;

const ItemPrice = styled.div`
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
`;

/* 주문자/배송지 박스 */
const SectionBox = styled.div`
  border-radius: 16px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  padding: 12px 14px;
  box-shadow: 0 3px 14px rgba(15, 23, 42, 0.05);
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const SectionTitle = styled.div`
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
`;

const FieldRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const FieldLabel = styled.label`
  font-size: 12px;
  color: #6b7280;
`;

const Input = styled.input`
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  padding: 7px 9px;
  font-size: 13px;
`;

const Textarea = styled.textarea`
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  padding: 7px 9px;
  font-size: 13px;
  resize: vertical;
  min-height: 60px;
`;

const AddressRow = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
`;

const AddressSearchButton = styled.button`
  border-radius: 8px;
  border: 1px solid #d1d5db;
  background: #e5edff;
  padding: 0 10px;
  height: 32px;
  font-size: 12px;
  font-weight: 600;
  color: #1d4ed8;
  white-space: nowrap;
  cursor: pointer;
`;

const SameRow = styled.div`
  display: flex;
  justify-content: flex-end;
  font-size: 11px;
  color: #6b7280;
  gap: 6px;
  align-items: center;
`;

const SectionHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`;

const SummaryBox = styled.div`
  margin-top: 4px;
  padding: 10px 12px;
  border-radius: 12px;
  background: #eef2ff;
  border: 1px solid #c7d2fe;
  font-size: 13px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: #4b5563;
`;

const SummaryTotal = styled.div`
  font-size: 15px;
  font-weight: 800;
  color: #111827;
`;

const SummaryActions = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 8px;
  justify-content: flex-end;
`;

const SummaryBtn = styled.button`
  appearance: none;
  border-radius: 999px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  padding: 7px 11px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  color: #4b5563;
`;

const SummaryPrimaryBtn = styled.button`
  appearance: none;
  border-radius: 999px;
  border: 0;
  background: #2563eb;
  padding: 7px 13px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  color: #ffffff;
`;

const EmptyBox = styled.div`
  margin-top: 40px;
  padding: 24px 14px;
  border-radius: 16px;
  border: 1px dashed #d1d5db;
  background: #ffffff;
  text-align: center;
  font-size: 13px;
  color: #9ca3af;
  line-height: 1.7;
`;

/* 입금 계좌 섹션 */
const BankSectionLabel = styled.h3`
  margin: 10px 0 2px;
  font-size: 14px;
  color: #0f172a;
  font-weight: 800;
`;

const BankSectionDivider = styled.hr`
  height: 1px;
  border: 0;
  background: #e5eaf5;
  margin: 0 0 8px;
`;

const BankBox = styled.div`
  border-radius: 12px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;

  .row {
    display: flex;
    gap: 8px;
    align-items: center;
    flex-wrap: wrap;
  }
  .copy {
    border: 1px solid #d1d5db;
    background: #fff;
    border-radius: 8px;
    padding: 6px 10px;
    font-size: 12px;
    cursor: pointer;
  }
`;

const Subtle = styled.div`
  color: #64748b;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.5;
`;

/* ✅ 포인트 사용 섹션 (FranchiseStoreDetailPage 스타일로 통일) */
const PointsBox = styled.div`
  border-radius: 16px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  padding: 12px 14px;
  box-shadow: 0 3px 14px rgba(15, 23, 42, 0.05);
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const PointsTopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

const PointsTitle = styled.div`
  font-size: 13px;
  font-weight: 800;
  color: #0f172a;
`;

const PointsBalance = styled.div`
  font-size: 12px;
  color: #475569;
`;

const PointsLine = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
`;

const PointsMiniBtns = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
`;

const PointsMiniBtn = styled.button`
  height: 30px;
  border-radius: 999px;
  border: 1px solid #e5e7eb;
  background: #fff;
  padding: 0 10px;
  font-size: 11px;
  cursor: pointer;
  color: #6b7280;
`;

const PointsHint = styled.div`
  font-size: 11px;
  color: #94a3b8;
  line-height: 1.4;
`;

const KRW = (n = 0) => Number(n || 0).toLocaleString("ko-KR") + "원";

function safeInt(v) {
    const n = Number(v);
    if (!Number.isFinite(n)) return 0;
    return Math.trunc(n);
}

const formatOptionText = (optionSelections) => {
    if (!Array.isArray(optionSelections) || !optionSelections.length) {
        return "선택된 옵션 없음";
    }
    return optionSelections
        .map((op) =>
            op.extraPrice
                ? `${op.groupName}: ${op.value} (+${KRW(op.extraPrice)})`
                : `${op.groupName}: ${op.value}`
        )
        .join(", ");
};

// ✅ 다음 우편번호 스크립트
const POSTCODE_SCRIPT_URL =
    "//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";

const loadPostcodeScript = () =>
    new Promise((resolve, reject) => {
        if (typeof window === "undefined") {
            reject(new Error("window is undefined"));
            return;
        }
        if (window.daum && window.daum.Postcode) {
            resolve();
            return;
        }
        const exists = document.querySelector(`script[src="${POSTCODE_SCRIPT_URL}"]`);
        if (exists) {
            exists.addEventListener("load", () => resolve());
            exists.addEventListener("error", reject);
            return;
        }
        const script = document.createElement("script");
        script.src = POSTCODE_SCRIPT_URL;
        script.async = true;
        script.onload = () => resolve();
        script.onerror = reject;
        document.body.appendChild(script);
    });

export default function StoreCartCheckoutPage() {
    const nav = useNavigate();
    const location = useLocation();
    const { phoneE164 } = useDriverStatusContext();

    const state = location.state || {};
    const initialItems = Array.isArray(state.items) ? state.items : [];

    const [items] = useState(initialItems);
    const [settings, setSettings] = useState(null);

    // ✅ 상품 계좌 캐시
    const [bankByProductId, setBankByProductId] = useState({});

    // 주문자/수령자 정보
    const [ordererName, setOrdererName] = useState("");
    const [ordererPhone, setOrdererPhone] = useState("");
    const [ordererEmail, setOrdererEmail] = useState("");
    const [ordererAddr1, setOrdererAddr1] = useState("");
    const [ordererAddr2, setOrdererAddr2] = useState("");

    const [recvName, setRecvName] = useState("");
    const [recvPhone, setRecvPhone] = useState("");
    const [recvAddr1, setRecvAddr1] = useState("");
    const [recvAddr2, setRecvAddr2] = useState("");
    const [recvMemo, setRecvMemo] = useState("");
    const [sameAsOrderer, setSameAsOrderer] = useState(false);

    const [profileLoading, setProfileLoading] = useState(true);
    const [hasDefaultProfile, setHasDefaultProfile] = useState(false);
    const [saveAsDefault, setSaveAsDefault] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    // ✅ 주소 검색(웹=팝업 / 앱=오버레이 embed)
    const [postcodeVisible, setPostcodeVisible] = useState(false);
    const postcodeTargetRef = useRef(null);
    const postcodeContainerRef = useRef(null);

    // ✅ 포인트
    const [pointsLoading, setPointsLoading] = useState(false);
    const [pointsBalance, setPointsBalance] = useState(0);
    const [usePoints, setUsePoints] = useState(0);

    const handlePostcodeComplete = (data, target) => {
        const addr = data.roadAddress || data.jibunAddress || "";
        const finalTarget = target || postcodeTargetRef.current || "orderer";

        if (finalTarget === "orderer") {
            setOrdererAddr1(addr);
            setOrdererAddr2("");
        } else if (finalTarget === "receiver") {
            setRecvAddr1(addr);
            setRecvAddr2("");
        }
    };

    const openPostcodeLayer = async (target) => {
        const isApp = typeof window !== "undefined" && !!window.ReactNativeWebView;

        if (!isApp) {
            try {
                await loadPostcodeScript();
                new window.daum.Postcode({
                    oncomplete: (data) => {
                        handlePostcodeComplete(data, target);
                    },
                }).open();
            } catch (e) {
                console.error(e);
                alert("주소 검색을 불러오지 못했어요. 잠시 후 다시 시도해주세요.");
            }
            return;
        }

        postcodeTargetRef.current = target;
        setPostcodeVisible(true);
    };

    const closePostcodeLayer = () => {
        setPostcodeVisible(false);
    };

    useEffect(() => {
        const isApp = typeof window !== "undefined" && !!window.ReactNativeWebView;
        if (!isApp) return;
        if (!postcodeVisible) return;

        let cancelled = false;

        (async () => {
            try {
                await loadPostcodeScript();
                if (cancelled) return;
                if (!postcodeContainerRef.current) return;

                const target = postcodeTargetRef.current || "orderer";

                const pc = new window.daum.Postcode({
                    oncomplete: (data) => {
                        handlePostcodeComplete(data, target);
                        setPostcodeVisible(false);
                    },
                    width: "100%",
                    height: "100%",
                });

                pc.embed(postcodeContainerRef.current);
            } catch (e) {
                console.error("[StoreCartCheckoutPage] postcode embed error", e);
                if (!cancelled) {
                    alert("주소 검색을 불러오지 못했어요. 잠시 후 다시 시도해주세요.");
                    setPostcodeVisible(false);
                }
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [postcodeVisible]);

    // 스토어 설정(배송 정책 포함) 로드 — ✅ 배송비 계산용으로만 유지
    useEffect(() => {
        let alive = true;
        (async () => {
            try {
                const s = await fetchStoreSettings();
                if (!alive) return;
                setSettings(s);
            } catch (e) {
                console.error("[StoreCartCheckoutPage] fetchStoreSettings error", e);
            }
        })();
        return () => {
            alive = false;
        };
    }, []);

    // ✅ 장바구니 아이템의 productId들로 bankAccount 로드
    useEffect(() => {
        let cancelled = false;

        const productIds = Array.from(
            new Set(
                (items || [])
                    .map((it) => (it?.productId ? String(it.productId) : ""))
                    .filter(Boolean)
            )
        );

        (async () => {
            try {
                if (!productIds.length) return;

                const missing = productIds.filter(
                    (pid) => !Object.prototype.hasOwnProperty.call(bankByProductId || {}, pid)
                );
                if (!missing.length) return;

                const nextMap = {};
                await Promise.all(
                    missing.map(async (pid) => {
                        try {
                            const p = await fetchProductById(pid);
                            const bank =
                                typeof p?.bankAccount === "string" ? p.bankAccount.trim() : "";
                            nextMap[pid] = bank || "";
                        } catch (e) {
                            console.error("[StoreCartCheckoutPage] fetchProductById error", pid, e);
                            nextMap[pid] = "";
                        }
                    })
                );

                if (cancelled) return;

                setBankByProductId((prev) => ({ ...(prev || {}), ...nextMap }));
            } catch (e) {
                console.error("[StoreCartCheckoutPage] build bank map error", e);
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [items, bankByProductId]);

    const bankText = useMemo(() => {
        if (!items.length) return "";
        const lines = items
            .map((it) => {
                const pid = it?.productId ? String(it.productId) : "";
                if (!pid) return "";
                const bank = bankByProductId?.[pid] || "";
                if (!bank) return "";
                return `${bank}`;
            })
            .filter(Boolean);

        return Array.from(new Set(lines)).join("\n");
    }, [items, bankByProductId]);

    // 기본 배송지 로드
    useEffect(() => {
        let cancelled = false;

        async function run() {
            if (!phoneE164) {
                setProfileLoading(false);
                return;
            }
            try {
                const profile = await getDefaultOrderProfile(phoneE164);
                if (cancelled) return;
                if (profile && profile.orderer) {
                    const o = profile.orderer;
                    const r = profile.receiver || profile.orderer;

                    setOrdererName(o.name || "");
                    setOrdererPhone(o.phone || "");
                    setOrdererEmail(o.email || "");
                    setOrdererAddr1(o.addr1 || "");
                    setOrdererAddr2(o.addr2 || "");

                    setRecvName(r.name || "");
                    setRecvPhone(r.phone || "");
                    setRecvAddr1(r.addr1 || "");
                    setRecvAddr2(r.addr2 || "");

                    setSameAsOrderer(
                        r.name === o.name && r.phone === o.phone && r.addr1 === o.addr1 && r.addr2 === o.addr2
                    );
                    setHasDefaultProfile(true);
                } else {
                    setHasDefaultProfile(false);
                }
            } catch (e) {
                console.error("[StoreCartCheckoutPage] load profile error", e);
            } finally {
                if (!cancelled) setProfileLoading(false);
            }
        }

        run();
        return () => {
            cancelled = true;
        };
    }, [phoneE164]);

    // ✅ 포인트 잔액 로드 + 초기화
    useEffect(() => {
        let cancelled = false;

        async function run() {
            setUsePoints(0);

            if (!phoneE164) {
                setPointsBalance(0);
                return;
            }
            try {
                setPointsLoading(true);
                const { balance } = await fetchMemberPointsBalance({ phoneE164 });
                if (cancelled) return;
                setPointsBalance(safeInt(balance));
            } catch (e) {
                console.error("[StoreCartCheckoutPage] fetchMemberPointsBalance error", e);
                if (!cancelled) setPointsBalance(0);
            } finally {
                if (!cancelled) setPointsLoading(false);
            }
        }

        run();
        return () => {
            cancelled = true;
        };
    }, [phoneE164]);

    // 주문자와 동일 토글
    const handleToggleSameAsOrderer = (e) => {
        const next = e.target.checked;
        setSameAsOrderer(next);
        if (next) {
            setRecvName(ordererName);
            setRecvPhone(ordererPhone);
            setRecvAddr1(ordererAddr1);
            setRecvAddr2(ordererAddr2);
        }
    };

    // 선택 상품 합계 (옵션 포함)
    const itemsTotal = useMemo(() => {
        if (!items.length) return 0;
        return items.reduce((sum, item) => {
            const base = Number(item.unitPrice || 0);
            const optExtra = Array.isArray(item.optionSelections)
                ? item.optionSelections.reduce((s, op) => s + Number(op.extraPrice || 0), 0)
                : 0;
            const qty = Number(item.qty || 1);
            const unitTotal = base + optExtra;
            return sum + unitTotal * qty;
        }, 0);
    }, [items]);

    // 스토어 배송 정책
    const shippingRule = settings?.shippingRule || {};
    const freeThreshold = Number(shippingRule.freeThreshold ?? 0);
    const baseFee = Number(shippingRule.baseFee ?? 0);

    // 장바구니 전체 기준 배송비 계산
    const shippingTotal = useMemo(() => {
        if (!items.length) return 0;
        if (freeThreshold > 0) {
            return itemsTotal >= freeThreshold ? 0 : baseFee;
        }
        return baseFee;
    }, [items.length, itemsTotal, freeThreshold, baseFee]);

    const totalPrice = itemsTotal + shippingTotal;

    const maxUsablePoints = useMemo(() => {
        const b = safeInt(pointsBalance);
        const t = safeInt(totalPrice);
        return Math.max(0, Math.min(b, t));
    }, [pointsBalance, totalPrice]);

    const pointsToUse = useMemo(() => {
        const u = Math.max(0, safeInt(usePoints));
        return Math.min(u, maxUsablePoints);
    }, [usePoints, maxUsablePoints]);

    const payableTotal = useMemo(() => {
        const t = safeInt(totalPrice);
        const u = safeInt(pointsToUse);
        return Math.max(0, t - u);
    }, [totalPrice, pointsToUse]);

    const validatePoints = () => {
        const u = safeInt(usePoints);
        if (u < 0) return { ok: false, msg: "포인트는 0 이상이어야 합니다." };
        if (u > safeInt(pointsBalance)) return { ok: false, msg: "보유 포인트를 초과할 수 없습니다." };
        if (u > safeInt(totalPrice)) return { ok: false, msg: "결제 예정 금액을 초과할 수 없습니다." };
        return { ok: true, msg: "" };
    };

    const handleClearDefaultProfile = async () => {
        if (!phoneE164) return;
        const ok = window.confirm("저장된 기본 배송지를 삭제할까요?");
        if (!ok) return;

        try {
            await clearDefaultOrderProfile(phoneE164);
            setHasDefaultProfile(false);
            setOrdererName("");
            setOrdererPhone("");
            setOrdererEmail("");
            setOrdererAddr1("");
            setOrdererAddr2("");
            setRecvName("");
            setRecvPhone("");
            setRecvAddr1("");
            setRecvAddr2("");
            setSameAsOrderer(false);
            alert("기본 배송지가 삭제되었습니다.");
        } catch (e) {
            console.error("[StoreCartCheckoutPage] clear profile error", e);
            alert("기본 배송지 삭제 중 오류가 발생했습니다.");
        }
    };

    const handleSubmitOrder = async () => {
        if (!phoneE164) {
            alert("로그인 정보가 없습니다. 홈에서 다시 접속해주세요.");
            return;
        }
        if (!items.length) {
            alert("주문할 상품 정보가 없습니다.\n장바구니에서 다시 선택해 주세요.");
            nav("/store/cart", { replace: true });
            return;
        }

        if (!ordererName.trim() || !ordererPhone.trim()) {
            alert("주문자 이름과 휴대폰 번호를 입력해주세요.");
            return;
        }
        if (!ordererAddr1.trim() || !ordererAddr2.trim()) {
            alert("주문자 주소를 모두 입력해주세요.");
            return;
        }
        if (!recvName.trim() || !recvPhone.trim()) {
            alert("받는 분 이름과 휴대폰 번호를 입력해주세요.");
            return;
        }
        if (!recvAddr1.trim() || !recvAddr2.trim()) {
            alert("배송 주소를 모두 입력해주세요.");
            return;
        }

        const pv = validatePoints();
        if (!pv.ok) {
            alert(pv.msg);
            return;
        }

        const ordererPayload = {
            name: ordererName.trim(),
            phone: ordererPhone.trim(),
            email: ordererEmail.trim(),
            zip: "",
            addr1: ordererAddr1.trim(),
            addr2: ordererAddr2.trim(),
        };

        const receiverPayload = {
            name: recvName.trim(),
            phone: recvPhone.trim(),
            zip: "",
            addr1: recvAddr1.trim(),
            addr2: recvAddr2.trim(),
            memo: recvMemo.trim(),
        };

        const itemPayloads = items.map((item, index) => ({
            productId: item.productId,
            productTitle: item.productTitle || item.productTitleSnapshot || "",
            thumb: item.thumb || "",
            unitPrice: Number(item.unitPrice || 0),
            qty: Number(item.qty || 1),
            optionSelections: Array.isArray(item.optionSelections)
                ? item.optionSelections.map((op) => ({
                    groupName: op.groupName || "",
                    value: op.value || "",
                    extraPrice: Number(op.extraPrice || 0),
                }))
                : [],
            shippingFeePerItem: index === 0 ? Number(shippingTotal || 0) : 0,
        }));

        const pointsUsed = safeInt(pointsToUse);
        const payable = safeInt(payableTotal);

        const ok = window.confirm(
            `주문을 신청할까요?\n\n` +
            `총 금액: ${KRW(totalPrice)}\n` +
            `${pointsUsed > 0 ? `포인트 사용: -${pointsUsed.toLocaleString("ko-KR")}P\n` : ""}` +
            `입금/결제 금액: ${KRW(payable)}`
        );
        if (!ok) return;

        try {
            setSubmitting(true);

            // 1) 주문 생성 (포인트 사용 정보도 같이 저장)
            const orderId = await createStoreOrder({
                ownerPhoneE164: phoneE164,
                items: itemPayloads,
                orderer: ordererPayload,
                receiver: receiverPayload,
                channel: "store",
                shippingTotal: Number(shippingTotal || 0),

                pointsUsed,
                payableTotal: payable,
            });

            // 2) 포인트 차감 (orderId 포함해서 원장 기록)
            if (pointsUsed > 0) {
                try {

                    const firstTitle =
                        String(items?.[0]?.productTitle || items?.[0]?.productTitleSnapshot || "").trim() || "상품";

                    const restCount = Math.max(0, (items?.length || 0) - 1);

                    const orderTitleSnapshot =
                        restCount > 0 ? `${firstTitle} 외 ${restCount}개` : firstTitle;
                    
                    await applyPointsChange({
                        memberId: phoneE164,
                        phoneE164,
                        delta: -pointsUsed,
                        reasonType: "ORDER_USE",
                        reason: "스토어 주문 결제 포인트 사용",
                        actorRole: "user",
                        actorId: phoneE164,
                        source: "order",
                        type: "deduct",
                        orderId,
                        orderTitleSnapshot
                    });

                    const { balance } = await fetchMemberPointsBalance({ phoneE164 });
                    setPointsBalance(safeInt(balance));
                } catch (e2) {
                    console.error("[StoreCartCheckoutPage] points deduct failed", e2);

                    // 주문 문서는 이미 생성됨 → 포인트 사용값은 되돌리고 안내
                    try {
                        await updateStoreOrder(orderId, {
                            pointsUsed: 0,
                            payableTotal: safeInt(totalPrice),
                            points: { used: 0 },
                            price: {
                                itemsTotal: safeInt(itemsTotal),
                                shippingTotal: safeInt(shippingTotal),
                                total: safeInt(totalPrice),
                                payableTotal: safeInt(totalPrice),
                            },
                            payment: { method: "bank_transfer", pointsUsed: 0 },
                            pointsError: String(e2?.message || "points deduct failed"),
                        });
                    } catch (e3) {
                        console.error("[StoreCartCheckoutPage] order patch after points fail error", e3);
                    }

                    alert(
                        "주문은 생성되었지만 포인트 차감에 실패했습니다.\n포인트는 사용되지 않은 상태로 주문이 접수됩니다.\n\n잠시 후 다시 시도해주세요."
                    );
                }
            }

            if (saveAsDefault) {
                try {
                    await saveDefaultOrderProfile(phoneE164, {
                        orderer: ordererPayload,
                        receiver: receiverPayload,
                    });
                    setHasDefaultProfile(true);
                } catch (e) {
                    console.error("[StoreCartCheckoutPage] save profile error", e);
                }
            }

            const toDeleteIds = items.map((it) => it.cartItemId).filter(Boolean);

            if (phoneE164 && toDeleteIds.length) {
                try {
                    await Promise.all(toDeleteIds.map((cid) => deleteStoreCartItem(phoneE164, cid)));
                } catch (e) {
                    console.error("[StoreCartCheckoutPage] delete cart items error", e);
                }
            }

            const goOrders = window.confirm(
                "주문이 접수되었어요.\n지금은 무통장 입금으로만 주문 가능합니다.\n\n입금 후 '주문 내역'에서 상태를 확인해 주세요.\n\n주문 내역 화면으로 이동할까요?"
            );
            if (goOrders) {
                nav("/store/orders", { replace: true });
            } else {
                nav("/store", { replace: true });
            }
        } catch (e) {
            console.error("[StoreCartCheckoutPage] create order error", e);
            alert("주문 처리 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.");
        } finally {
            setSubmitting(false);
        }
    };

    // state 없이 직접 진입한 경우 방어
    if (!items.length) {
        return (
            <Wrap>
                <Sheet>
                    <PageTopBar variant="back" to="/store/cart" label="장바구니로 이동" />
                    <Body>
                        <BrandHeader subtitle="장바구니 주문" />
                        <EmptyBox>
                            주문할 상품 정보가 없습니다.
                            <br />
                            장바구니에서 주문할 상품을 선택해 주세요.
                        </EmptyBox>
                    </Body>
                </Sheet>
            </Wrap>
        );
    }

    const showBank = !!bankText;

    return (
        <Wrap>
            <Sheet>
                <PageTopBar variant="back" to="/store/cart" label="장바구니로 이동" />

                <Body>
                    <BrandHeader subtitle="장바구니 주문" />

                    <InfoText>
                        장바구니에서 선택한 상품을 한 번에 주문합니다.
                        <br />
                        주문자 정보와 배송 정보를 입력한 뒤 주문을 완료해 주세요.
                    </InfoText>

                    {/* 선택 상품 리스트 */}
                    <ItemsBox>
                        <SectionTitle>주문 상품</SectionTitle>
                        {items.map((item) => {
                            const optText = formatOptionText(item.optionSelections);
                            const base = Number(item.unitPrice || 0);
                            const optExtra = Array.isArray(item.optionSelections)
                                ? item.optionSelections.reduce((s, op) => s + Number(op.extraPrice || 0), 0)
                                : 0;
                            const qty = Number(item.qty || 1);
                            const unitTotal = base + optExtra;
                            const subTotal = unitTotal * qty;

                            return (
                                <ItemRow key={item.cartItemId || item.productId}>
                                    <Thumb>
                                        {item.thumb ? <img src={item.thumb} alt="" /> : <span>이미지 없음</span>}
                                    </Thumb>
                                    <ItemContent>
                                        <ItemTitle>
                                            {item.productTitle || item.productTitleSnapshot || "상품명 없음"}
                                        </ItemTitle>
                                        <ItemOption>{optText}</ItemOption>
                                        <ItemMetaRow>
                                            <ItemQty>수량 {qty}개</ItemQty>
                                            <ItemPrice>{KRW(subTotal)}</ItemPrice>
                                        </ItemMetaRow>
                                    </ItemContent>
                                </ItemRow>
                            );
                        })}
                    </ItemsBox>

                    {/* 주문자 정보 */}
                    <SectionBox>
                        <SectionTitle>주문자 정보</SectionTitle>
                        <FieldRow>
                            <FieldLabel>이름</FieldLabel>
                            <Input
                                value={ordererName}
                                onChange={(e) => setOrdererName(e.target.value)}
                                placeholder="주문자 이름"
                            />
                        </FieldRow>
                        <FieldRow>
                            <FieldLabel>휴대폰 번호</FieldLabel>
                            <Input
                                value={ordererPhone}
                                onChange={(e) => setOrdererPhone(e.target.value)}
                                placeholder="예: 010-0000-0000"
                            />
                        </FieldRow>
                        <FieldRow>
                            <FieldLabel>이메일 (선택)</FieldLabel>
                            <Input
                                value={ordererEmail}
                                onChange={(e) => setOrdererEmail(e.target.value)}
                                placeholder="주문 내역 안내를 받을 이메일"
                            />
                        </FieldRow>
                        <FieldRow>
                            <FieldLabel>주소</FieldLabel>
                            <AddressRow>
                                <Input
                                    value={ordererAddr1}
                                    onChange={(e) => setOrdererAddr1(e.target.value)}
                                    placeholder="기본 주소"
                                />
                                <AddressSearchButton type="button" onClick={() => openPostcodeLayer("orderer")}>
                                    주소 찾기
                                </AddressSearchButton>
                            </AddressRow>
                        </FieldRow>
                        <FieldRow>
                            <Input
                                value={ordererAddr2}
                                onChange={(e) => setOrdererAddr2(e.target.value)}
                                placeholder="상세 주소"
                            />
                        </FieldRow>

                        <FieldRow>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    gap: 8,
                                    marginTop: 4,
                                }}
                            >
                                <label
                                    style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: 6,
                                        fontSize: 11,
                                        color: "#6b7280",
                                        cursor: "pointer",
                                    }}
                                >
                                    <input
                                        type="checkbox"
                                        checked={saveAsDefault}
                                        disabled={profileLoading || !phoneE164}
                                        onChange={(e) => setSaveAsDefault(e.target.checked)}
                                        style={{ width: 14, height: 14 }}
                                    />
                                    <span>이 정보를 기본 배송지로 저장</span>
                                </label>
                                {hasDefaultProfile && (
                                    <button
                                        type="button"
                                        onClick={handleClearDefaultProfile}
                                        style={{
                                            fontSize: 11,
                                            padding: "4px 8px",
                                            borderRadius: 999,
                                            border: "1px solid #e5e7eb",
                                            background: "#fff",
                                            cursor: "pointer",
                                            color: "#6b7280",
                                        }}
                                    >
                                        기본정보 삭제
                                    </button>
                                )}
                            </div>
                            {saveAsDefault && (
                                <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 2 }}>
                                    다음 주문부터 자동으로 이 정보가 채워집니다.
                                </div>
                            )}
                        </FieldRow>
                    </SectionBox>

                    {/* 배송 정보 */}
                    <SectionBox>
                        <SectionHeaderRow>
                            <SectionTitle>배송 정보</SectionTitle>
                            <SameRow>
                                <input
                                    type="checkbox"
                                    checked={sameAsOrderer}
                                    onChange={handleToggleSameAsOrderer}
                                    style={{ width: 14, height: 14 }}
                                />
                                <span>주문자 정보와 동일</span>
                            </SameRow>
                        </SectionHeaderRow>
                        <FieldRow>
                            <FieldLabel>받는 분 이름</FieldLabel>
                            <Input value={recvName} onChange={(e) => setRecvName(e.target.value)} placeholder="수령인 이름" />
                        </FieldRow>
                        <FieldRow>
                            <FieldLabel>휴대폰 번호</FieldLabel>
                            <Input
                                value={recvPhone}
                                onChange={(e) => setRecvPhone(e.target.value)}
                                placeholder="예: 010-0000-0000"
                            />
                        </FieldRow>
                        <FieldRow>
                            <FieldLabel>배송 주소</FieldLabel>
                            <AddressRow>
                                <Input value={recvAddr1} onChange={(e) => setRecvAddr1(e.target.value)} placeholder="기본 주소" />
                                <AddressSearchButton type="button" onClick={() => openPostcodeLayer("receiver")}>
                                    주소 찾기
                                </AddressSearchButton>
                            </AddressRow>
                        </FieldRow>
                        <FieldRow>
                            <Input value={recvAddr2} onChange={(e) => setRecvAddr2(e.target.value)} placeholder="상세 주소" />
                        </FieldRow>
                        <FieldRow>
                            <FieldLabel>배송 요청사항 (선택)</FieldLabel>
                            <Textarea
                                value={recvMemo}
                                onChange={(e) => setRecvMemo(e.target.value)}
                                placeholder="예) 부재 시 경비실에 맡겨주세요."
                            />
                        </FieldRow>
                    </SectionBox>

                    {/* ✅ 포인트 사용 (단순 입력 + 최대/사용안함) */}
                    <PointsBox>
                        <PointsTopRow>
                            <PointsTitle>포인트 사용</PointsTitle>
                            <PointsBalance>
                                {pointsLoading ? "조회중…" : `보유: ${safeInt(pointsBalance).toLocaleString("ko-KR")}P`}
                            </PointsBalance>
                        </PointsTopRow>

                        <PointsLine>
                            <div style={{ display: "flex", flexDirection: "column", gap: 4, minWidth: 0 }}>
                                <FieldLabel style={{ margin: 0 }}>사용할 포인트</FieldLabel>
                                <Input
                                    inputMode="numeric"
                                    value={String(usePoints ?? 0)}
                                    onChange={(e) => {
                                        const v = safeInt(String(e.target.value || "").replace(/[^\d]/g, ""));
                                        setUsePoints(v);
                                    }}
                                    placeholder="0"
                                    disabled={submitting}
                                />
                            </div>

                            <PointsMiniBtns>
                                <PointsMiniBtn
                                    type="button"
                                    onClick={() => setUsePoints(maxUsablePoints)}
                                    disabled={submitting || pointsLoading || maxUsablePoints <= 0}
                                >
                                    최대 사용
                                </PointsMiniBtn>
                                <PointsMiniBtn type="button" onClick={() => setUsePoints(0)} disabled={submitting}>
                                    사용 안함
                                </PointsMiniBtn>
                            </PointsMiniBtns>
                        </PointsLine>

                        <PointsHint>
                            최대 사용 가능: {safeInt(maxUsablePoints).toLocaleString("ko-KR")}P (총 금액과 보유 포인트 중 작은 값)
                            <br />
                            결제 예정 금액 및 보유 포인트를 초과할 수 없습니다.
                        </PointsHint>
                    </PointsBox>

                    {/* ✅ 입금 계좌 (상품 bankAccount 기반) */}
                    {showBank ? (
                        <SectionBox>
                            <BankSectionLabel>입금 계좌</BankSectionLabel>
                            <BankSectionDivider />
                            <BankBox>
                                <div className="row">
                                    <div style={{ fontWeight: 400, color: "#0f172a", whiteSpace: "pre-line" }}>
                                        {bankText}
                                    </div>
                                    <button
                                        className="copy"
                                        type="button"
                                        onClick={() => {
                                            navigator.clipboard?.writeText(bankText).then(() => alert("계좌번호를 복사했어요."));
                                        }}
                                    >
                                        계좌 복사
                                    </button>
                                </div>
                                <Subtle>지금은 무통장 입금으로만 주문이 가능합니다.</Subtle>
                            </BankBox>
                        </SectionBox>
                    ) : null}

                    {/* 합계 / 버튼 */}
                    <SummaryBox>
                        <SummaryRow>
                            <span>상품가 합계 (옵션 포함)</span>
                            <span>{KRW(itemsTotal)}</span>
                        </SummaryRow>
                        <SummaryRow>
                            <span>배송비</span>
                            <span>{KRW(shippingTotal)}</span>
                        </SummaryRow>
                        <SummaryRow>
                            <span>총 결제 예정 금액</span>
                            <span>{KRW(totalPrice)}</span>
                        </SummaryRow>

                        {pointsToUse > 0 ? (
                            <SummaryRow>
                                <span>포인트 사용</span>
                                <span>-{safeInt(pointsToUse).toLocaleString("ko-KR")}P</span>
                            </SummaryRow>
                        ) : null}

                        <SummaryRow>
                            <SummaryTotal>입금/결제 금액</SummaryTotal>
                            <SummaryTotal>{KRW(payableTotal)}</SummaryTotal>
                        </SummaryRow>
                    </SummaryBox>

                    <SummaryActions>
                        <SummaryBtn type="button" onClick={() => nav("/store/cart")}>
                            장바구니로 돌아가기
                        </SummaryBtn>
                        <SummaryPrimaryBtn type="button" onClick={handleSubmitOrder} disabled={submitting}>
                            {submitting ? "주문 처리 중..." : "주문 신청하기"}
                        </SummaryPrimaryBtn>
                    </SummaryActions>
                </Body>

                {/* ✅ 앱(WebView)용 주소 검색 오버레이 */}
                {postcodeVisible && (
                    <PostcodeOverlay onClick={closePostcodeLayer}>
                        <PostcodePanel onClick={(e) => e.stopPropagation()}>
                            <PostcodeHeader>
                                <PostcodeTitle>주소 검색</PostcodeTitle>
                                <PostcodeCloseButton type="button" onClick={closePostcodeLayer}>
                                    닫기
                                </PostcodeCloseButton>
                            </PostcodeHeader>
                            <PostcodeBody>
                                <div ref={postcodeContainerRef} style={{ width: "100%", height: "100%" }} />
                            </PostcodeBody>
                        </PostcodePanel>
                    </PostcodeOverlay>
                )}
            </Sheet>
        </Wrap>
    );
}

/* ===== Postcode UI ===== */

const PostcodeOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 90;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const PostcodePanel = styled.div`
  width: 100%;
  max-width: 480px;
  height: 70vh;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.4);
  display: flex;
  flex-direction: column;
  padding: 8px 10px 10px;
`;

const PostcodeHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 4px 2px 8px;
  border-bottom: 1px solid #e5e7eb;
`;

const PostcodeTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
`;

const PostcodeCloseButton = styled.button`
  border: 0;
  background: transparent;
  padding: 4px 6px;
  border-radius: 999px;
  cursor: pointer;
  font-size: 13px;
  color: #6b7280;
  &:hover {
    background: #f3f4f6;
  }
`;

const PostcodeBody = styled.div`
  flex: 1;
  margin-top: 6px;
  border-radius: 12px;
  overflow: hidden;
  background: #f9fafb;
`;
